import React, { CSSProperties, ReactNode, useState } from 'react';

import classnames from 'classnames';
import './Card.scoped.scss';

interface Props {
  style?: CSSProperties;
  className?: string;
  title?: string | ReactNode;
  content?: string;
  children?: React.ReactNode;
  Header?: React.ReactNode;
  average?: number;
  headerClasses?: string;
  foldable?: boolean;
}

const Card: React.FC<Props> & { Header: React.FC<Props>; Body: React.FC<Props> } = ({
  className,
  children,
  title = '',
  foldable = false,
}) => {
  const [folded, setFolded] = useState(true);

  const toggleFold = () => {
    setFolded(!folded);
  };

  return (
    <div className={`card-container ${className}`}>
      {foldable && (
        <>
          <div className={classnames({ 'foldable-header': true, folded })} onClick={toggleFold}>
            {title} <button className="fold-button"></button>
          </div>

          <div className={classnames({ fold: true, open: !folded })}>{children}</div>
        </>
      )}

      {!foldable && children}
    </div>
  );
};

Card.Header = (props: Props) => {
  return (
    <div className={`card-header ${props.headerClasses}`} style={props.style}>
      {props.children}
    </div>
  );
};

Card.Body = (props: Props) => (
  <div className={`card-body ${props?.className}`} style={props.style}>
    {props.children}
  </div>
);

export default Card;
